export const DoppeActionTypeCouponViewerLang = {
    defaultTexts: {
        couponButtonText: 'Shop'
    }
}